import {
  TypedUseSelectorHook,
  useDispatch as reduxUseDispatch,
  useSelector as reduxUseSelector
} from 'react-redux';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

export type AppDispatch = ThunkDispatch<
  RootState[keyof RootState],
  unknown,
  AnyAction
>;

export const useAppDispatch = () => reduxUseDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<RootState> = reduxUseSelector;
